import type { CompleteServiceExecutionFragment } from '@drycut/graphql';

import { Stack } from '@drycut/ui-components';

import QueueTable from '../QueueTable';
import RequeueServiceButton from './RequeueServiceButton';

type Props = {
  serviceExecution: CompleteServiceExecutionFragment;
};

export default function OnHoldServiceRow({ serviceExecution }: Props): React.ReactElement {
  return (
    <tr className="antialiased text-left font-aribau bg-zinc-200 text-xs">
      <QueueTable.TableCell className="text-[0.65rem] text-zinc-500">
        {serviceExecution.booking.bookingCode}
      </QueueTable.TableCell>

      <QueueTable.TableCell className="font-aribaubold">
        {serviceExecution.booking.customName || serviceExecution.customer?.name}
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        <Stack direction="row" className="items-center justify-end">
          <RequeueServiceButton serviceExecution={serviceExecution} />
        </Stack>
      </QueueTable.TableCell>
    </tr>
  );
}
